import { useConnectDishToSatellite } from 'features/dishes/api/connectDishToSatellite';
import { Dispatch, SetStateAction, useState } from 'react';
import { NodeData } from 'reaflow';
import { AnalyzerDish } from '../../../types';
import { useUpdateDish } from '../../dishes/api/updateDish';
import { useSystemOverview } from '../api/getSystemOverview';
import { getNodeId } from '../utils/nodeHandlers';

export const useLinkNodeHandler = (
  setSelectedNode: Dispatch<SetStateAction<string>>,
  setAnalyzerDish: Dispatch<
    SetStateAction<undefined | Omit<AnalyzerDish, 'id'>>
  >,
  setAnalyzerIdToPair: Dispatch<SetStateAction<number>>
) => {
  const { data: systemOverview } = useSystemOverview({});
  const updateDish = useUpdateDish({});
  const connectDishToSatellite = useConnectDishToSatellite({});
  const [switchIdToPair, setSwitchIdToPair] = useState<number>(-1);
  const handleLinkNodes = (from: NodeData<any>, to: NodeData<any>) => {
    // Don't create a duplicate pairing
    if (from.id.startsWith('dish') && to.id.startsWith('switch')) {
      if (
        systemOverview?.dishes[Number(getNodeId(from.id))].switchIds.includes(
          getNodeId(to.id)
        )
      )
        return;
      setSelectedNode(from.id);
      setAnalyzerDish({
        port: 1,
        feed_name: '',
        polarity: null,
        link_type: null,
        analyzer_id: null,
        switch_id: getNodeId(to.id),
        dish_id: getNodeId(from.id),
        lo: null,
      });
    } else if (from.id.startsWith('switch') && to.id.startsWith('dish')) {
      if (
        systemOverview?.dishes[Number(getNodeId(to.id))].switchIds.includes(
          getNodeId(from.id)
        )
      )
        return;
      setSelectedNode(to.id);
      setAnalyzerDish({
        port: 1,
        feed_name: '',
        polarity: null,
        link_type: null,
        analyzer_id: null,
        switch_id: getNodeId(from.id),
        dish_id: getNodeId(to.id),
        lo: null,
      });
    } else if (from.id.startsWith('dish') && to.id.startsWith('analyzer')) {
      if (
        systemOverview?.dishes[Number(getNodeId(from.id))].analyzerIds.includes(
          getNodeId(to.id)
        )
      )
        return;
      setSelectedNode(from.id);
      setAnalyzerDish({
        port: 1,
        feed_name: '',
        polarity: null,
        link_type: null,
        analyzer_id: getNodeId(to.id),
        switch_id: null,
        dish_id: getNodeId(from.id),
        lo: null,
      });
    } else if (from.id.startsWith('analyzer') && to.id.startsWith('dish')) {
      if (
        systemOverview?.dishes[Number(getNodeId(to.id))].analyzerIds.includes(
          getNodeId(from.id)
        )
      )
        return;
      setSelectedNode(to.id);
      setAnalyzerDish({
        port: 1,
        feed_name: '',
        polarity: null,
        link_type: null,
        analyzer_id: getNodeId(from.id),
        switch_id: null,
        dish_id: getNodeId(to.id),
        lo: null,
      });
    } else if (from.id.startsWith('satellite') && to.id.startsWith('dish')) {
      if (
        systemOverview?.satellites[Number(getNodeId(from.id))].dishIds.includes(
          getNodeId(to.id)
        )
      )
        return;

      connectDishToSatellite.mutateAsync({
        dish_id: getNodeId(to.id),
        satellite_id: getNodeId(from.id),
      });
    } else if (to.id.startsWith('satellite') && from.id.startsWith('dish')) {
      if (
        systemOverview?.satellites[Number(getNodeId(to.id))].dishIds.includes(
          getNodeId(from.id)
        )
      )
        return;
      connectDishToSatellite.mutateAsync({
        dish_id: getNodeId(from.id),
        satellite_id: getNodeId(to.id),
      });
    } else if (from.id.startsWith('location') && to.id.startsWith('dish')) {
      if (
        systemOverview?.dishes[Number(getNodeId(to.id))].locationId ===
        getNodeId(from.id)
      )
        return;
      updateDish.mutateAsync({
        dishId: getNodeId(to.id),
        data: { location_id: getNodeId(from.id) },
      });
    } else if (to.id.startsWith('location') && from.id.startsWith('dish')) {
      if (
        systemOverview?.dishes[Number(getNodeId(from.id))].locationId ===
        getNodeId(to.id)
      )
        return;
      updateDish.mutateAsync({
        dishId: getNodeId(from.id),
        data: { location_id: getNodeId(to.id) },
      });
    } else if (from.id.startsWith('analyzer') && to.id.startsWith('switch')) {
      if (
        systemOverview?.analyzers[
          Number(getNodeId(from.id))
        ].switchIds.includes(getNodeId(to.id))
      )
        return;
      setAnalyzerIdToPair(Number(getNodeId(from.id)));
      setSwitchIdToPair(Number(getNodeId(to.id)));
    } else if (to.id.startsWith('analyzer') && from.id.startsWith('switch')) {
      if (
        systemOverview?.analyzers[Number(getNodeId(to.id))].switchIds.includes(
          getNodeId(from.id)
        )
      )
        return;
      setAnalyzerIdToPair(Number(getNodeId(to.id)));
      setSwitchIdToPair(Number(getNodeId(from.id)));
    }
  };
  return { handleLinkNodes, switchIdToPair };
};
